import axios from 'axios';
import { API_URL } from 'api/api';

const OAuthApi = this;

OAuthApi.token = (username, password) => {
    // This is an edge case, because we are sending everything as form-urlencoded

    const body =
        'grant_type=password' +
        '&client_id=' + encodeURIComponent(process.env.OAUTH_CLIENT_ID) +
        '&client_secret=' + encodeURIComponent(process.env.OAUTH_CLIENT_SECRET) +
        '&username=' + encodeURIComponent(username) +
        '&password=' + encodeURIComponent(password);

    return axios.post(`${API_URL}/oauth/v2/token`, body, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
};

export default OAuthApi;


// WEBPACK FOOTER //
// ./src/api/oauth.js